import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

const PorownaniePakietow = () => {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const tabs = [
    { id: '1', label: 'Lekarze' },
    { id: '2', label: 'Badania laboratoryjne' },
    { id: '3', label: 'Badania obrazowe, endoskopowe i czynnościowe' },
    { id: '4', label: 'Zabiegi ambulatoryjne' },
    { id: '5', label: 'Pozostałe' }
  ];

  const baseStyle = {
    color: 'rgb(0, 60, 125)',
    fontWeight: '600',
    fontSize: '1.05rem',
    padding: '12px 18px',
    border: 'none',
    borderRadius: '6px 6px 0 0',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out'
  };

  const activeStyle = {
    backgroundColor: 'rgb(0, 60, 125)',
    color: 'white',
    fontWeight: '700'
  };

  return (
    <>
      <h3 className="page-header firstColor">
        Porównanie pakietu medycznego – Komfort
      </h3>

      <Nav tabs style={{ borderBottom: '2px solid rgba(0, 60, 125, 0.2)' }}>
        {tabs.map((tab) => (
          <NavItem key={tab.id}>
            <NavLink
              onClick={() => toggle(tab.id)}
              style={{
                ...baseStyle,
                ...(activeTab === tab.id ? activeStyle : {})
              }}>
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent activeTab={activeTab}>
        {/* --- TAB 1: LEKARZE --- */}
        <TabPane tabId="1">
          {/* <p className="secondColor">
            Porady lekarskie realizowane są bez skierowania w sytuacjach
            chorobowych, udzielane przez lekarzy specjalistów wskazanych przez
            Świadczeniodawcę w godzinach pracy placówek medycznych oraz zgodnie
            z aktualnym harmonogramem pracy placówek.
          </p> */}

          <p className="secondColor">
            <strong>
              T - lekarz dostępny również w ramach usług telemedycznych
            </strong>
          </p>

          <table className="table table-striped table-bordered secondColor">
            <tbody>
              <tr>
                <th>Komfort</th>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li>T internista</li>
                    <li>T lekarz rodzinny</li>
                    <li>T pediatra</li>
                    <li>T alergolog</li>
                    <li>T chirurg ogólny</li>
                    <li>T dermatolog</li>
                    <li>T diabetolog</li>
                    <li>T endokrynolog</li>
                    <li>T gastrolog</li>
                    <li>T ginekolog</li>
                    <li>ginekolog-endokrynolog</li>
                    <li>ginekolog-onkolog</li>
                    <li>T kardiolog</li>
                    <li>T neurolog</li>
                    <li>T okulista</li>
                    <li>T onkolog</li>
                    <li>T ortopeda</li>
                    <li>T otolaryngolog</li>
                    <li>proktolog</li>
                    <li>T urolog</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <p className="secondColor">
            Szczegółowy opis zakresu dostępny w sekcji{' '}
            <a
              href="https://tvp-tuwpzuw.uspartner.pl/pracownicy2026/dokumenty/"
              target="_blank"
              rel="noopener noreferrer">
              Dokumenty do pobrania
            </a>
            .
          </p>
        </TabPane>

        {/* --- TAB 2: BADANIA LABORATORYJNE --- */}
        <TabPane tabId="2">
          <table className="table table-striped table-bordered secondColor">
            <thead>
              <tr>
                <th>Kategoria badań</th>
                <th>Liczba rodzajów badań</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Morfologia krwi obwodowej</td>
                <td>4</td>
              </tr>
              <tr>
                <td>Układ krzepnięcia</td>
                <td>2</td>
              </tr>
              <tr>
                <td>Badania biochemiczne</td>
                <td>32</td>
              </tr>
              <tr>
                <td>Badania serologiczne</td>
                <td>7</td>
              </tr>
              <tr>
                <td>Diagnostyka zakażeń</td>
                <td>21</td>
              </tr>
              <tr>
                <td>Badania hormonalne</td>
                <td>4</td>
              </tr>
              <tr>
                <td>Badania moczu</td>
                <td>1</td>
              </tr>
              <tr>
                <td>Badania kału</td>
                <td>2</td>
              </tr>
              <tr>
                <td>Testy alergiczne</td>
                <td>5</td>
              </tr>
              <tr>
                <td>Badania inne</td>
                <td>2</td>
              </tr>
            </tbody>
          </table>
        </TabPane>

        {/* --- TAB 3: BADANIA OBRAZOWE, ENDOSKOPOWE I CZYNNOŚCIOWE --- */}
        <TabPane tabId="3">
          <div className="secondColor">
            <p>
              <strong>Komfort</strong>
            </p>

            <p>
              <strong>Badania radiologiczne:</strong> RTG czaszki, zatok nosa,
              klatki piersiowej w projekcji Pa i bocznej – również z barytem,
              kręgosłupa, stawów, kończyny górnej, kończyny dolnej, miednicy,
              przeglądowe jamy brzusznej, mammografia
            </p>

            <p>
              <strong>Badania czynnościowe</strong>
              <br />
              EKG spoczynkowe, spirometria, audiometria tonalna, audiometria
              impedancyjna (tympanogram)
            </p>

            <p>
              <strong>Badania inne</strong>
              <br />
              Densytometria kręgosłupa, kości udowej, kości obu rąk
            </p>

            <p>
              <strong>Badania ultrasonograficzne</strong>
              <br />
              USG gruczołu krokowego przez powłoki brzuszne, gruczołu krokowego
              transrektalne, ginekologiczne przez powłoki brzuszne,
              ginekologiczne przezpochwowe (transwaginalne), piersi, przeglądowe
              jamy brzusznej i przewodu pokarmowego (trzustki, wątroby, dróg
              żółciowych, żołądka, dwunastnicy), tarczycy, stawów: biodrowych,
              kolanowych, łokciowych, skokowych, barkowych, drobnych stawów i
              więzadeł, ścięgna, jąder, ciąży, ślinianek, echokardiografia
              (ECHO).
            </p>
          </div>
        </TabPane>

        {/* --- TAB 4: ZABIEGI AMBULATORYJNE --- */}
        <TabPane tabId="4">
          <div className="secondColor">
            <p>
              <strong>Komfort</strong>
            </p>

            <p>
              Zabiegi wykonywane są w ramach porady lekarskiej przez lekarza lub
              pielęgniarkę, z zastrzeżeniem, że istnieje wskazanie medyczne i
              możliwość wykonania czynności w warunkach ambulatoryjnych w danej
              placówce bez szkody dla Ubezpieczonego.
            </p>

            <ul>
              <li>Odczulanie (bez kosztu podawanych leków)</li>
              <li>Nacięcie i drenaż ropnia</li>
              <li>Szycie rany</li>
              <li>Założenia i zmiana opatrunku</li>
              <li>Zdjęcie szwów</li>
              <li>Pobieranie materiału do badania cytologicznego</li>
              <li>Badanie dna oka</li>
              <li>Badanie ostrości widzenia</li>
              <li>Pomiar ciśnienia śródgałkowego</li>
              <li>Usunięcie ciała obcego</li>
              <li>Dobór szkieł korekcyjnych</li>
              <li>
                Opatrzenie drobnych urazów (skręcenia, zwichnięcia,
                nieskomplikowane złamania – bez kosztów stabilizatorów i gipsu)
              </li>
              <li>Założenie temblaka</li>
              <li>Założenie/zdjęcie gipsu (w tym gipsu lekkiego)</li>
              <li>Płukanie uszu</li>
              <li>Przedmuchiwanie trąbki słuchowej</li>
              <li>Usunięcie ciała obcego z ucha/nosa/gardła</li>
              <li>Punkcja w tym m.in. zatoki szczękowej</li>
              <li>Założenie/zmiana przedniej tamponady nosa</li>
              <li>Pobieranie materiałów do badań mikrobiologicznych</li>
              <li>
                Opatrzenie drobnych urazów (rany, skręcenia, zwichnięcia,
                nieskomplikowane złamania – bez kosztu stabilizatorów i gipsu)
              </li>
              <li>Usunięcie kleszcza</li>
              <li>Opatrunki związane z oparzeniami</li>
              <li>Iniekcje: domięśniowe, dożylne, podskórne</li>
              <li>Podłączenie wlewu kroplowego</li>
              <li>Pobieranie krwi</li>
              <li>Test troponinowy</li>
            </ul>
          </div>
        </TabPane>

        {/* --- TAB 5: POZOSTAŁE --- */}
        <TabPane tabId="5">
          <div className="secondColor">
            <p>
              <strong>Pakiet Profilaktyczny</strong>
              <br />
              Raz w roku bez skierowania:
            </p>
            <ul>
              <li>morfologia krwi z pełnym różnicowaniem granulocytów</li>
              <li>glukoza</li>
              <li>lipidogram</li>
              <li>mocz – badanie ogólne</li>
              <li>standardowa cytologia ginekologiczna</li>
            </ul>

            <p>
              <strong>Konsultacje lekarzy pomocy doraźnej</strong>
              <br />
              Porady obejmują tylko przypadki nagłych zachorowań lub nagłego
              pogorszenia stanu zdrowia, z wyłączeniem stanów bezpośredniego
              zagrożenia życia. Decyzja o konieczności realizacji konsultacji
              lekarza pomocy doraźnej podejmowana jest na podstawie
              przeprowadzonego wywiadu.
            </p>
            <ul>
              <li>lekarz pomocy doraźnej internistycznej</li>
              <li>lekarz pomocy doraźnej pediatrycznej</li>
              <li>pomoc ortopedyczna</li>
              <li>pomoc chirurgiczna</li>
            </ul>

            <p>
              <strong>Hot line</strong>
              <br />
              Całodobowe infolinia medyczna, dostępna 7 dni w tygodniu, również
              w święta i dni ustawowo wolne od pracy, gdzie można otrzymać
              pielęgniarską telekonsultację medyczną.
            </p>
            <p>Pielęgniarka w ramach posiadanych uprawnień zawodowych:</p>
            <ul>
              <li>zidentyfikuje problem medyczny</li>
              <li>
                udzieli porady medycznej, jeśli dany przypadek na to pozwala
              </li>
              <li>
                wystawi receptę na leki niezbędne do leczenia zgłoszonego
                problemu zdrowotnego, na wystawienie których pozwalają
                pielęgniarskie uprawnienia zawodowe
              </li>
            </ul>

            <p>
              <strong>Prowadzenie ciąży</strong>
              <br />
              Prowadzenie ciąży fizjologicznej obejmuje opiekę lekarza
              ginekologa, konsultacje i badania diagnostyczne oraz czynne
              poradnictwo w zakresie fizjologii przebiegu ciąży i porodu,
              zgodnie z zakresem ubezpieczenia. Badania realizowane zgodnie ze
              wskazaniami medycznymi na podstawie skierowania w placówkach
              wskazanych przez Świadczeniodawcę za pośrednictwem infolinii
              medycznej lub serwisu moje.pzu.pl.
            </p>

            <p>
              <strong>Telekonsultacja z położną</strong>
              <br />
              Tematem rozmowy z położną w ramach jej posiadanych uprawnień
              zawodowych jest poradnictwo dotyczące: zdrowego stylu życia w
              ciąży, fizjologii przebiegu ciąży i porodu, połogu, pielęgnacji i
              żywienia noworodka.
            </p>

            <p>
              <strong>Szczepienia</strong>
              <br />
              Bezpłatnie, raz w roku:
            </p>
            <ul>
              <li>Szczepienie przeciwko grypie sezonowej</li>
            </ul>
            <p>Bezpłatnie, bez limitu:</p>
            <ul>
              <li>Anatoksyna przeciw tężcowi</li>
              <li>Szczepienie przeciwko błonicy</li>
            </ul>

            <p>
              <strong>Wizyty domowe</strong>
              <br />
              Bezpłatnie, 2 wizyty w roku
            </p>

            <p>
              <strong>Stomatologia zachowawcza</strong>
              <br />
              Bezpłatny, raz w roku: przegląd stomatologiczny, lakierowanie,
              instruktaż higieny, polerowanie, scaling, piaskowanie, lakowanie,
              fluoryzacja oraz 10% zniżki na 21 rodzajów zabiegów stomatologii
              zachowawczej
            </p>
          </div>
        </TabPane>
      </TabContent>
    </>
  );
};

export default PorownaniePakietow;
